<template>
  <div class="mobile-entry">
    <div class="mobile-header" @click="pageReload">
      <img class="logo" src="../assets/logo-black.png" alt="logo" />
      <div class="title">授权系统</div>
    </div>

    <a-tabs :animated="false" size="large" @change="resetForm">
      <a-tab-pane tab="串号查询" key="3">
        <a-form class="mobile-form" :form="anonymityForm">
          <a-form-item>
            <a-input
              size="large"
              type="text"
              placeholder="请输入串号"
              v-decorator="[
                'serialNumber',
                { rules: [{ required: true, message: '请输入串号' }], validateTrigger: 'blur' }
              ]"
              @keyup.enter="anonymitySubmit"
            />
          </a-form-item>

          <a-form-item style="margin-top: 16px">
            <a-button
              size="large"
              type="primary"
              class="primary-btn"
              :loading="loading_btn"
              :disabled="loading_btn"
              @click="anonymitySubmit"
            >查询</a-button>
          </a-form-item>
        </a-form>
      </a-tab-pane>

      <a-tab-pane tab="绑定操作" key="4">
        <a-form v-if="status === ''" class="mobile-form" :form="bindForm">
          <a-form-item>
            <a-select v-model="operation" size="large" :defaultActiveFirstOption="false">
              <a-select-option value="bind">绑定硬件</a-select-option>
              <a-select-option value="unbind">解绑硬件</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item>
            <a-input
              size="large"
              type="text"
              placeholder="请输入串号"
              v-decorator="[
                'serialNumber',
                { rules: [{ required: true, message: '请输入串号' }] }
              ]"
            />
          </a-form-item>

          <a-form-item>
            <a-input
              size="large"
              type="text"
              placeholder="请输入串号密钥"
              v-decorator="[
                'serialCipher',
                { rules: [{ required: true, message: '请输入串号密钥' }] }
              ]"
            />
          </a-form-item>

          <a-form-item v-if="operation === 'bind'">
            <a-input
              size="large"
              type="text"
              placeholder="请输入绑定硬件密文"
              v-decorator="[
                'bindCipher',
                { rules: [{ required: true, message: '请输入绑定硬件密文' }, { min: 16, max: 16, message: '长度必须16个字符', trigger: 'blur' }] }
              ]"
              @keyup.enter="bindSubmit"
            />
          </a-form-item>

          <a-form-item v-if="operation === 'unbind'">
            <a-input
              size="large"
              type="text"
              placeholder="请输入解绑硬件密文"
              v-decorator="[
                'unbindCipher',
                { rules: [{ required: true, message: '请输入解绑硬件密文' }, { min: 16, max: 16, message: '长度必须16个字符', trigger: 'blur' }] }
              ]"
              @keyup.enter="bindSubmit"
            />
          </a-form-item>

          <a-form-item style="margin-top: 16px">
            <a-button
              size="large"
              type="primary"
              class="primary-btn"
              :loading="loading_btn"
              :disabled="loading_btn"
              @click="bindSubmit"
            >{{ btnText }}</a-button>
          </a-form-item>
        </a-form>

        <a-result
          v-else
          :status="status"
          :title="`${btnText}${statusText}`"
          :sub-title="subTitle"
        >
          <template #extra>
            <a-button @click="reload">再次{{ btnText }}</a-button>
          </template>
        </a-result>
      </a-tab-pane>

      <a-tab-pane tab="结果校验" key="5">
        <a-form class="mobile-form" :form="checkForm">
          <a-form-item>
            <a-input
              size="large"
              type="text"
              placeholder="请输入机号"
              allow-clear
              v-decorator="[
                'serialNumber',
                { rules: [{ required: true, message: '请输入机号' }] }
              ]"
              @keyup.enter="checkSubmit"
            />
          </a-form-item>

          <a-form-item>
            <a-input
              size="large"
              type="text"
              placeholder="请输入AHAICRC"
              allow-clear
              v-decorator="['ahaiCrc']"
              @keyup.enter="checkSubmit"
            />
          </a-form-item>

          <a-form-item>
            <a-input
              size="large"
              type="text"
              placeholder="请输入AHAISUM"
              allow-clear
              v-decorator="['ahaiSum']"
              @keyup.enter="checkSubmit"
            />
          </a-form-item>

          <a-form-item style="margin-top: 16px">
            <a-button
              size="large"
              type="primary"
              class="primary-btn"
              :loading="loading_btn"
              :disabled="loading_btn"
              @click="checkSubmit"
            >校验</a-button>
          </a-form-item>
        </a-form>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { bindDevice, unbindDevice } from '../api/api'

export default {
  name: 'login-mobile',

  data() {
    return {
      anonymityForm: this.$form.createForm(this),
      bindForm: this.$form.createForm(this),
      checkForm: this.$form.createForm(this),
      loading_btn: false,
      operation: 'bind',

      status: '',
      subTitle: '',
    }
  },

  computed: {
    btnText() {
      return this.operation === 'bind' ? '绑定' : '解绑'
    },

    statusText() {
      return this.status === 'success' ? '成功' : '失败'
    },
  },

  methods: {
    pageReload() {
      document.location.reload()
    },

    resetForm() {
      this.anonymityForm.resetFields()
      this.bindForm.resetFields()
      this.checkForm.resetFields()
      this.status = ''
      this.subTitle = ''
    },

    anonymitySubmit() {
      this.loading_btn = true
      this.anonymityForm.validateFields((err, values) => {
        if (!err) {
          const serialNumber = (values.serialNumber || '').trim()
          const redirectUri = encodeURI(
            `${this.$web_url}anonymity-query-mobile/${serialNumber}`
          )
          const oauthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.$app_id}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base#wechat_redirect`
          window.location.href = oauthUrl
        }
      })
      setTimeout(() => {
        this.loading_btn = false
      }, 300)
    },

    bindSubmit() {
      this.loading_btn = true
      this.bindForm.validateFields((err, values) => {
        if (!err) {
          this.status = ''
          if (this.operation === 'bind') {
            bindDevice(values).then(res => {
              if (res.error.code === 0) {
                this.status = 'success'
                this.subTitle = `授权码：${res.response.authorizationCode}`
              } else {
                this.status = 'error'
                this.subTitle = res.error.msg
              }
            })
          } else if (this.operation === 'unbind') {
            unbindDevice(values).then(res => {
              if (res.error.code === 0) {
                this.status = 'success'
              } else {
                this.status = 'error'
                this.subTitle = res.error.msg
              }
            })
          }
        }
      })
      setTimeout(() => {
        this.loading_btn = false
      }, 300)
    },

    reload() {
      this.bindForm.resetFields()
      this.status = ''
      this.subTitle = ''
    },

    checkSubmit() {
      this.checkForm.validateFields((err, values) => {
        if (!err) {
          const query = {
            serialNumber: (values.serialNumber || '').trim(),
            ahaiCrc: (values.ahaiCrc || '').trim(),
            ahaiSum: (values.ahaiSum || '').trim(),
          }
          this.$router.push({ name: 'result-checking', query })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-tabs-bar {
  margin-top: 12px;
  margin-bottom: 12px;
}

.mobile-entry {
  min-height: 100vh;
  background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
  background-size: cover;
  padding: 16px 12px 20px;
}

.mobile-header {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 6px;
  cursor: pointer;

  .logo {
    height: 28px;
    display: inline-block;
    margin-bottom: 10px;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    color: #080404;
    line-height: 28px;
  }

  .subtitle {
    margin-top: 6px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    line-height: 18px;
  }
}

.mobile-form {
  max-width: 420px;
  margin: 0 auto;
}

.primary-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
}

/deep/ .ant-form-item {
  margin-bottom: 14px;
}

</style>

